import { scaleTransformFoo } from '../../../../../../../../../tools/scaleTransformFoo';
import { Props } from './interfaces';
import React, { useId } from 'react';
import { Shape } from 'react-konva';
import { KonvaEventObject } from 'konva/lib/Node';
import useHatchingLines from '../../../../hooks/useHatchingLines';

/**
 * Компонент, отвечающий за отображения слоя периметра
 * @param selectedMarker Выбранный маркер
 * @param selectObject Функция для выбора маркера отчетного объекта
 * @param stageScale Масштаб холста
 * @param heatColor Цвет, который зависит от значения метрики
 * @param object Сам объект
 * @param floor Этаж, где находится отчетный объект
 * @param plan Информация о плане
 */
const Perimeter: React.FC<Props> = ({
    heatColor,
    onMouseLeave: onMouseLeaveTrans,
    onMouseOver: onMouseOverTrans,
    selectedMarker,
    stageScale = 1,
    selectObject,
    availableMarkers,
    changeStageCursor,
    stageIndex,
    object,
    floor,
    plan,
}) => {
    const hatchingLines = useHatchingLines();
    const id = useId();

    const onClick = (e: KonvaEventObject<MouseEvent>) => {
        e.cancelBubble = true;
        if (selectObject) {
            if (Array.isArray(availableMarkers)) {
                availableMarkers.includes(String(floor)) && selectObject(String(floor));
            } else {
                selectObject(String(floor));
            }
        }
    };

    const onMouseOver = (e: KonvaEventObject<MouseEvent>) => {
        if (Array.isArray(availableMarkers)) {
            !availableMarkers.includes(String(floor)) && changeStageCursor(stageIndex, 'not-allowed')();
        }
        e.cancelBubble = true;
        onMouseOverTrans && onMouseOverTrans(String(floor));
    };

    const onMouseLeave = (e: KonvaEventObject<MouseEvent>) => {
        if (Array.isArray(availableMarkers)) {
            !availableMarkers.includes(String(floor)) && changeStageCursor(stageIndex, 'pointer')();
        }
        e.cancelBubble = true;
        onMouseLeaveTrans && onMouseLeaveTrans(null);
    };

    return (
        <Shape
            sceneFunc={(context, shape) => {
                context.beginPath();
                context.moveTo(object.coords.coordinates[0][0], object.coords.coordinates[0][1]);
                object.coords.coordinates.forEach((coord: number[], i: number) => {
                    if (i > 0) {
                        context.lineTo(coord[0], coord[1]);
                    }
                });
                context.lineTo(object.coords.coordinates[0][0], object.coords.coordinates[0][1]);
                context.fillStrokeShape(shape);
            }}
            fill={selectedMarker !== String(floor) ? heatColor || 'rgba(0,0,0,0.3)' : 'rgba(85, 125, 249, .7)'}
            // fillPatternImage={selectedMarker === String(floor) ? hatchingLines : undefined}
            // fillPatternY={selectedMarker === String(floor) ? 89 / plan.height : undefined}
            // fillPatternX={selectedMarker === String(floor) ? 89 / plan.width : undefined}
            stroke={selectedMarker === String(floor) ? 'black' : undefined}
            // strokeWidth={scaleTransformFoo(25, plan.scale)}
            onMouseLeave={onMouseLeave}
            onMouseOver={onMouseOver}
            key={`perometer-${id}`}
            id={`perometer-${id}`}
            onClick={onClick}
            opacity={1}
        />
    );
};

export default Perimeter;
